import {FC} from "react";
import {Form, Input, Rate} from "antd";
import TextArea from "antd/es/input/TextArea";
import "./style.less"
import {VALIDATION_MESSAGES} from "../../../../../enums/validationMessages";
import {FeedbackFormData, FeedbackFormProps} from "../../../../../types/feedback";
import {UserOutlined} from "@ant-design/icons";
import {DEFAULT_MAX_INPUT_LENGTH, DEFAULT_MAX_TEXTAREA_LENGTH} from "../../../../../constants/validation";
import {getImageLink} from "../../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../../enums/buckets";


const initialRate = 5

const FeedbackForm: FC<FeedbackFormProps> = (props) => {
  const {staffController} = props
  const {feedbackForm, selectedStaff, createFeedbackHandler} = staffController


  const onFinishHandler = (formData: FeedbackFormData) => {
    createFeedbackHandler({...formData, staff: selectedStaff?.$id || ""})
  }

  return <Form className="feedback_form" layout="vertical" form={feedbackForm} onFinish={onFinishHandler}
               initialValues={{rate: initialRate}}>
    {selectedStaff && <div className="feedback-form-person">
      <div className="feedback-form-person__photo">
        {selectedStaff.image ? <img
          src={getImageLink({imageId: selectedStaff.image, bucketId: BUCKETS.MAIN})}
          alt={`Фото: ${selectedStaff.fullName}`}
        /> : <span>{selectedStaff.fullName?.trim().charAt(0) || "Л"}</span>}
      </div>
      <div className="feedback-form-person__content">
        <small>Відгук про фахівця</small>
        <strong>{selectedStaff.fullName}</strong>
        <span>{selectedStaff.position}</span>
      </div>
    </div>}

    <p className="feedback_form__description">
      Поділіться враженнями про консультацію або лікування. Ваш відгук допоможе нам покращувати якість медичної допомоги.
    </p>

    <Form.Item
      name="author"
      label="Ваше ім’я"
      extra="Поле не обов’язкове — можна залишити відгук анонімно"
      rules={[{max: DEFAULT_MAX_INPUT_LENGTH, message: `Максимум ${DEFAULT_MAX_INPUT_LENGTH} символів`}]}
    >
      <Input size="large" prefix={<UserOutlined/>} placeholder="Як до вас звертатися?" maxLength={DEFAULT_MAX_INPUT_LENGTH}/>
    </Form.Item>

    <Form.Item name="feedback" label="Ваш відгук" rules={[
      {required: true, message: VALIDATION_MESSAGES.REQUIRED},
      {max: DEFAULT_MAX_TEXTAREA_LENGTH, message: `Максимум ${DEFAULT_MAX_TEXTAREA_LENGTH} символів`}
    ]}>
      <TextArea rows={5} showCount maxLength={DEFAULT_MAX_TEXTAREA_LENGTH}
                placeholder="Розкажіть про ваш досвід..."/>
    </Form.Item>

    <div className="feedback-form-rating">
      <div><small>Загальна оцінка</small><strong>Оцініть якість обслуговування</strong></div>
      <Form.Item name="rate" rules={[{required: true, message: "Оберіть оцінку"}]}>
        <Rate allowHalf/>
      </Form.Item>
    </div>
  </Form>
}

export default FeedbackForm
